import type { Alert, AlertStatus } from "../types";
import { apiFetch } from "./client";
import {
  canonicalStockyPublicBigIntId,
  type StockyPublicBigIntId,
} from "./stocky_public_ids";

function normalizeAlert(value: unknown): Alert {
  if (value === null || typeof value !== "object") {
    throw new TypeError("alert response is invalid");
  }
  const alert = value as Omit<
    Alert,
    "id" | "shopify_variant_id" | "supplier_id"
  > & {
    id: unknown;
    shopify_variant_id: unknown;
    supplier_id?: unknown;
  };
  return {
    ...alert,
    id: canonicalStockyPublicBigIntId(alert.id),
    shopify_variant_id: canonicalStockyPublicBigIntId(
      alert.shopify_variant_id,
    ),
    supplier_id:
      alert.supplier_id === null || alert.supplier_id === undefined
        ? alert.supplier_id
        : canonicalStockyPublicBigIntId(alert.supplier_id),
  };
}

export function listAlerts(opts: {
  status?: AlertStatus;
  limit?: number;
} = {}): Promise<Alert[]> {
  return apiFetch<unknown>("/api/alerts", {
    query: { status: opts.status, limit: opts.limit },
  }).then((value) => {
    if (!Array.isArray(value)) {
      throw new TypeError("alerts response is invalid");
    }
    return value.map(normalizeAlert);
  });
}

export async function dismissAlert(
  id: StockyPublicBigIntId,
): Promise<{ id: string; status: string }> {
  const canonicalId = canonicalStockyPublicBigIntId(id);
  const value = await apiFetch<unknown>(`/api/alerts/${canonicalId}/dismiss`, {
    method: "PATCH",
  });
  if (value === null || typeof value !== "object") {
    throw new TypeError("alert dismissal response is invalid");
  }
  const response = value as { id?: unknown; status?: unknown };
  if (typeof response.status !== "string") {
    throw new TypeError("alert dismissal response is invalid");
  }
  return {
    id: canonicalStockyPublicBigIntId(response.id),
    status: response.status,
  };
}
